import React, {useContext, useEffect} from "react"
import {useGetCalculationsQuery} from "../../../store/api";
import CalculationContext from "../context";
import {useDispatch} from "react-redux";
import {useField} from "../store/fields-slice";
import { Loader} from "rsuite";
import {DialogAction} from "./action";
import {loadCalculation} from "../store/load-calculation";
import SioIcon from "../../../icon/rsuite-icon-font/SioIcon";
import { updateManualReload } from "../store/state-slice";

export function Calculations() {
    const id = useField("id")
    const {itinerary, organization, hasMarginTax, urlUtils} = useContext(CalculationContext)
    const dispatch = useDispatch()
    const {data: calculations = [], isLoading, refetch} = useGetCalculationsQuery(itinerary, {
        pollingInterval: 3 * 60 * 1000, // 3min
        refetchOnMountOrArgChange: true,
        skip: false
    })

    const showCurrencies = 1 < new Set(calculations.map(({currency}) => currency)).size
    const active = calculations.filter(({active}) => active)
    const inactive = calculations.filter(({active}) => !active)

    useEffect(
        () => {
            if (!isLoading) {
                let calculation = new URLSearchParams(document.location.search.substring(1)).get('calculation')
                if (calculation) {
                    calculation = calculations.find(({id}) => id === calculation)
                }
                if (calculation) {
                    selectCalculation(calculation)
                    return
                }
                if (active.length) {
                    selectCalculation(active[0])
                } else if (inactive.length) {
                    selectCalculation(inactive[0])
                }
            }
        },
        [isLoading]
    )

    const context = {
        moduleId: "tourism-journey-calculation",
        viewId: "calculation-create",
        contextObjectRef: {id: itinerary, modelId: "tourism/itinerary"}
    };

    return (
        <nav className="navbar navbar-default">
            {isLoading ? (
                <div className="navbar-text">
                    <Loader/>
                </div>
            ) : (
                <>
                    <CalculationsSelect
                        title="Aktiv"
                        calculations={active}
                        id={id}
                        showCurrencies={showCurrencies}
                        selectCalculation={selectCalculation}
                    />
                    <CalculationsSelect
                        title="Inaktiv"
                        calculations={inactive}
                        id={id}
                        showCurrencies={showCurrencies}
                        selectCalculation={selectCalculation}
                    />
                </>
            )}

            <div className="navbar-right navbar-text">
                <DialogAction
                    icon={<SioIcon icon=" fa fa-plus"/>}
                    appearance="primary"
                    color="green"
                    context={context}
                    onResult={onResult}
                />
            </div>
        </nav>
    )

    function onResult(calculation) {
        refetch() // @fixme should not be necessary here
        selectCalculation(calculation)
        dispatch(updateManualReload(true))
    }

    function selectCalculation(calculation) {
        urlUtils.setParams("calculation", calculation.id)
        dispatch(loadCalculation(calculation, organization, hasMarginTax))
        dispatch(updateManualReload(true))
    }
}



const CalculationsSelect = (
    {
        id,
        calculations,
        title,
        selectCalculation,
        showCurrencies
    }
) =>
{
    const sortedCalculations = calculations?.length > 0 ? calculations.sort(function(a, b) {
        var dateA = a?.dateRanges.length > 0 ? new Date(a?.dateRanges[0].fromDate) : "";
        var dateB = b?.dateRanges.length > 0 ? new Date(b?.dateRanges[0].fromDate) : "";
        return dateA - dateB;
    }) : [];

 return (
    <>
    {!sortedCalculations.length ? null : (
        <>
            <div className="navbar-header">
                <span className="navbar-brand">{title}:</span>
            </div>

            <ul className="nav navbar-nav">
                {sortedCalculations.map(calculation => {
                    const [title, subtitle] = calculation.label.split("\n")
                    const additionalLabel = calculation.additionalLabel ?? null;

                    return (
                        <li key={calculation.id} className={id === calculation.id ? "active" : ""}>
                            <a onClick={() => selectCalculation(calculation)} style={additionalLabel ? {paddingTop: 0} : {}}>
                                {additionalLabel && (<small className="above">{additionalLabel}</small>)}
                                {showCurrencies && <small className="currency below">{calculation.currency}</small>}
                                {title}
                                {subtitle && <small className="below"><br/>{subtitle}</small>}
                            </a>
                        </li>
                    )
                })}
            </ul>
        </>)}
    </>
    )
}
